import { jsx as _jsx } from "react/jsx-runtime";
// Components
import { Link } from '@kubit/web-ui-product-components';
// Configurations
import { linkConfigurationPropsConversion } from '../../components/link/configurations/link.configuration';
const LinkComponent = ({ analytics, ...props }) => (_jsx(Link, { ...linkConfigurationPropsConversion(props) }));
export { LinkComponent };
//# sourceMappingURL=link.component.js.map